import { PreaggregationStrategy } from '../../preaggregation/preaggregation-strategy';
import { DriverTypeFilter } from '../driver-types/driver-type-filter';
import { Card } from './card';
import { LegendItem } from './legend-item';
import { DimensionsFilter } from '../dimensions-filtering/dimensions-filter';
import { BalanceCard } from './balance-card';
import { DriverSelectionAlgorithm } from '../cards/driver-selection-algorithm';
import { Quickview } from './quickview';
import { ProcessingProgressDto } from '../processing-progress-dto';
import { ForecastWalk } from './forecast-walk';
import { DriverTypeWithIndex } from '../driver-types/driver-type-with-index';
import { DriverType } from '../driver-types/driver-type';
import { DimensionValue } from './dimension-value';

export enum ViewMode {
    normal,
    edit,
    rename,
}

export class VarianceModel {
    public cards: Card[];
    public balanceCard: BalanceCard;
    public outOfScopeCards: Card[];

    public outComeBeforeOutOfScope: number;
    public outcomeAfterOutOfScope: number;
    public oldControlValue: string;
    public newControlValue: string;
    public quickview: Quickview;
    
    public oldTotalOutcome: number;
    public newTotalOutcome: number;
    public fromTot: number;
    public fromSeq: number;
    public fromInSeq: number;
}

export interface IHasStory {
    story: string;
    loadingStory: boolean;
}

export class CardsModel implements IHasStory {
    public viewId: string;
    public tabUId: string;
    public name: string;
    public isSelected: boolean;
    public mode: ViewMode = ViewMode.normal;

    public processingInProgress: boolean;
    public currentProcessingProgess: ProcessingProgressDto;
    public warningText: string;

    public variance: VarianceModel;
    public forecast: VarianceModel | null;

    public algorithm: DriverSelectionAlgorithm;
    public driverTypeFilter: DriverTypeFilter;
    public dimensionsFilter: DimensionsFilter;
    public outcomeName: string;
   
    public legend: LegendItem[][];
    public undoAvailable: boolean;
    public redoAvailable: boolean;
    public preaggregationStrategy: PreaggregationStrategy;
    public minDriverDepth: number;
    public maxDriverDepth: number;
    public minDriverValue: number;
    public tabs: Tab[];
    public selectedTabId: string;
    public scopeDriverTypeNames: string[];
    public selectedDiagramSeriesName: string;
    public forecastWalk: ForecastWalk;  //TODO: remove
    public story: string;
    public loadingStory: boolean;

    public mainTabIsMarkedCompatible: boolean = false;
}

export class TabAddress {
    public viewId: string;
    public tabId: string;
}

export class Tab implements IHasStory {
    public id: string;
    public tabUId: string;
    public parentTabId: string;
    public cardIndexInParentTab: number;
    
    public variance: VarianceModel;
    public forecast: VarianceModel | null;

    public toSeqBeforeOutOfScope: number;
    public toSeqAfterOutOfScope: number;
    public toTotBeforeOutOfScope: number;
    public toTotAfterOutOfScope: number;
    public header: string;
    public displayDimensionValues: DimensionValue[];
    public startOutcome: number;
    public endOutcome: number;
    public outComeAfterOutOfScope: number;
    public driverTypeName: string;
    public driverType: DriverType;
    public availableDriverTypes: DriverTypeWithIndex[];
    public formulaComponentIndex: number;
    public selectedViewDriverTypes: DriverTypeWithIndex[];
    public algorithm: DriverSelectionAlgorithm;
    public minDriverDepth: number;
    public maxDriverDepth: number;
    public minDriverValue: number;
    public legend: LegendItem[][];
    public dimensionValues: DimensionValue[][];
    public scopeDriverTypeNames: string[];
    public story: string;
    public loadingStory: boolean;

    public isMarkedCompatible: boolean = false;
}